import React, { useEffect } from 'react';
import Avatar from '../../submodule/img/01.jpg';
import { useNavigate, useParams } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from '../../redux/actions/user/createUser';
import Loading from '../../components/Loading/Loading';
import Swal from 'sweetalert2';
import { resetCreateUser } from '../../redux/slices/user.slice';
import { createEmployer } from '../../redux/actions/employer/createEmployer';
import { resetCreateEmployer } from '../../redux/slices/employer.slice';

function AddUser() {
  const { role } = useParams();
  const navigate = useNavigate();
  console.log(role);
  useEffect(() => {
    if (role !== 'admin' && role !== 'manager' && role !== 'user') {
      navigate('/');
    }
  }, [role]);
  const dispatch = useDispatch();
  const {
    createUser: { data: createUserData, error: createUserError, loading: createUserLoading },
  } = useSelector((state) => state.user);
  const {
    createEmployer: { data: createEmployerData, error: createEmployerError, loading: createEmployerLoading },
  } = useSelector((state) => state.employer);

  const onSubmit = (data) => {
    if (role == 'user') {
      dispatch(
        createEmployer({
          name: data.fio,
          email: data.email,
          type: data.type,
        }),
      );
    } else {
      dispatch(
        createUser({
          full_name: data.fio,
          email: data.email,
          ...(role == 'admin' ? { type: 'staff', role: 'admin' } : role == 'manager' ? { type: 'staff', role: 'manager' } : {}),
        }),
      );
    }
  };
  const form = useForm({
    defaultValues: {
      email: '',
      fio: '',
      type: 'ie',
    },
  });
  useEffect(() => {
    if (createUserData) {
      Swal.fire({
        title: 'Пользователь создан. Пароль отправлен на почту пользователя',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      form.reset();
      dispatch(resetCreateUser());
    }
  }, [createUserData]);
  useEffect(() => {
    if (createEmployerData) {
      Swal.fire({
        title: 'Контрагент создан. Пароль отправлен на почту пользователя',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      form.reset();
      dispatch(resetCreateEmployer());
    }
  }, [createEmployerData]);
  const types = [
    {
      label: 'ИП',
      value: 'ie',
    },
    {
      label: 'Организация',
      value: 'company',
    },
    {
      label: 'Физическое лицо',
      value: 'individual',
    },
  ];
  const typeWatch = form.watch('type');
  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <div className="container relative flex flex-1 flex-col mx-auto max-w-[1163px]">
        <div className="flex flex-col sm:flex-row w-full gap-3 ">
          <div className="flex w-full sm:w-[20%] mb-2 justify-center">
            <div className="bg-[#E5E5E5] w-[160px] h-[160px] m-5 flex items-center justify-center rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
                <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
              </svg>
            </div>
          </div>
          <div className="flex flex-col w-full sm:w-[50%] mb-2 p-5 gap-3">
            <h2 className="text-[25px] font-normal text-black">Добавить {role == 'user' ? 'котрагента' : role == 'admin' ? 'админа' : role == 'manager' ? 'менеджера' : ''}</h2>
            {role == 'user' && (
              <fieldset className="flex w-full first:flex-row xs: flex-col gap-4 mb-1">
                <legend className="mb-4 text-[14px]">Тип пользователя</legend>
                <Controller
                  control={form.control}
                  name={'type'}
                  render={({ field: { onChange, ...props } }) =>
                    types.map((option, index) => (
                      <div className="relative flex gap-x-3" key={option.value}>
                        <div className="flex h-6 items-center">
                          <input
                            type="radio"
                            id={option.value}
                            {...props}
                            onChange={(e) => {
                              onChange(e);
                            }}
                            value={option.value}
                            defaultChecked={typeWatch == option.value}
                            checked={typeWatch == option.value}
                            // className={'focus:none'}
                            className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                          />
                        </div>
                        <div className="text-sm leading-6">
                          <label htmlFor={option.value} className="font-medium text-gray-900">
                            {option.label}
                          </label>
                        </div>
                      </div>
                    ))
                  }
                />
              </fieldset>
            )}
            <div className="">
              <Input form={form} name="fio" placeholder={'ФИО'} disabled={createUserLoading || createEmployerLoading} />
            </div>
            <Input
              form={form}
              name="email"
              placeholder={'Email'}
              rules={{
                required: { value: true, message: '*Обязательное поле для заполнения' },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Неверный формат почты',
                },
              }}
              disabled={createUserLoading || createEmployerLoading}
            />

            {/* <div className="">
              <div className="relative flex gap-x-3">
                <div className="flex h-6 items-center">
                  <input id="role1" name="role1" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                </div>
                <div className="text-sm leading-6">
                  <label htmlFor="role1" className="font-medium text-gray-900">
                    Полномочие администратора
                  </label>
                </div>
              </div>
            </div>
            <div className="">
              <div className="relative flex gap-x-3">
                <div className="flex h-6 items-center">
                  <input id="role2" name="role2" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                </div>
                <div className="text-sm leading-6">
                  <label htmlFor="role2" className="font-medium text-gray-900">
                    Полномочие администратора
                  </label>
                </div>
              </div>
            </div>
            <div className="">
              <div className="relative flex gap-x-3">
                <div className="flex h-6 items-center">
                  <input id="role3" name="role3" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                </div>
                <div className="text-sm leading-6">
                  <label htmlFor="role3" className="font-medium text-gray-900">
                    Полномочие администратора
                  </label>
                </div>
              </div>
            </div>
            <div className="">
              <div className="relative flex gap-x-3">
                <div className="flex h-6 items-center">
                  <input id="role4" name="role4" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                </div>
                <div className="text-sm leading-6">
                  <label htmlFor="role4" className="font-medium text-gray-900">
                    Полномочие администратора
                  </label>
                </div>
              </div>
            </div> */}
            <div className="flex flex-row gap-3 relative">
              <button onClick={form.handleSubmit(onSubmit)} type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-auto transition ease-in-out duration-300">
                Сохранить
              </button>
              <button
                onClick={() => {
                  navigate(-1);
                }}
                type="button"
                className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                Отмена
              </button>
              {(createUserLoading || createEmployerLoading) && (
                <div className="translate-x-5">
                  <Loading />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUser;
